export * from './typography.variants.defaults';
